import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  LuBox,
  LuChevronRight
} from 'react-icons/lu';
import { getImageUrl } from '../../utils/imageUtils';

export const RecentListings = ({ listings }) => {
  const navigate = useNavigate();
  const recentListings = listings?.slice(0, 3) || [];

  const getStatusStyle = (status) => {
    switch (status) {
      case 'active': return 'bg-green-100 text-green-800';
      case 'sold': return 'bg-red-100 text-red-800';
      case 'draft': return 'bg-yellow-100 text-yellow-800';
      default: return 'bg-gray-100 text-gray-600';
    }
  };

  const navigateToAllListings = () => {
    navigate('/store/listings');
  };

  const navigateToListingDetails = (listingId) => {
    navigate(`/store/listings/listing-details/${listingId}`);
  };

  if (recentListings.length === 0) {
    return (
      <>
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-bold text-black">Recent Listings</h2>
          <button 
            onClick={() => navigate('/store/listings/create-listing')}
            className="text-orange-600 text-sm font-semibold hover:text-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500 rounded"
          >
            Create New
          </button>
        </div>
        <div className="flex flex-col items-center w-full py-5 bg-gray-50 rounded-xl">
          <LuBox className="w-12 h-12 text-gray-400 mb-2" />
          <h3 className="font-semibold text-gray-900 mb-1">No Listings Yet</h3>
          <p className="text-gray-600 text-sm text-center">
            Create your first listing to start selling
          </p>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-bold text-black">Recent Listings</h2>
        <button 
          onClick={navigateToAllListings}
          className="text-orange-600 text-sm font-semibold hover:text-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500 rounded"
        >
          See All
        </button>
      </div>
      
      <div className="space-y-3">
        {recentListings.map((listing) => {
          const statusStyle = getStatusStyle(listing.status);
          return (
            <button
              key={listing.listing_id || listing.id}
              className="flex items-center w-full p-3 bg-gray-50 rounded-lg hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-orange-500 transition-all"
              onClick={() => navigateToListingDetails(listing.listing_id || listing.id)}
            >
              <img
                src={
                  getImageUrl(listing.images?.[0]?.image_url)
                   || 
                  'https://via.placeholder.com/60x60/f5f5f5/cccccc?text=IMG'
                }
                alt={listing.title}
                className="w-[60px] h-[60px] rounded-lg object-cover flex-shrink-0"
              />
              <div className="ml-3 flex-1 text-left min-w-0">
                <h3 className="font-semibold text-gray-900 truncate mb-1">
                  {listing.title}
                </h3>
                <p className="font-bold text-orange-600 mb-1">
                  ₦{parseFloat(listing.price || 0).toLocaleString()}
                </p>
                <div className="flex justify-between">
                  <span className={`px-2 py-1 rounded text-xs font-semibold ${statusStyle}`}>
                    {listing.moderation_status}
                  </span>
                  <span className="text-gray-600 text-xs">
                    👁️ {listing.view_count || 0}
                  </span>
                </div>
              </div>
              <LuChevronRight className="w-5 h-5 text-gray-400 ml-2 flex-shrink-0" />
            </button>
          );
        })}
      </div>
    </>
  );
};

export default RecentListings;